// extracted by mini-css-extract-plugin
module.exports = {"borderRight":"style_borderRight__QeEs4","skeletonContainer":"style_skeletonContainer___9_Ng"};